<template>
  <div class="age-and-fit-pg">
    <progress-bar/>

    <div id="input-form" class="input-form">
      <div class="form-group no-margin">
        <span class="form-input-title-label">Your age</span>
        <span class="form-input-sub-label">Why do we ask? Age has an impact on how your weight is distributed. Knowing your age helps us recommend the right size.</span>

        <div class="form-input">
          <input inputmode="numeric"
                 pattern="[0-9]*"
                 type="text"
                 v-model.trim="$v.age.$model"
                 class="text-input inline"
                 :class="{'is-invalid': $v.age.$error, populated: $v.age.$model !== ''}">

          <div class="input-error" v-if="$v.age.$error && $v.age.$dirty">{{ ageError }}</div>
        </div>
      </div>

      <div id="fit-preference" class="form-group">
        <span class="form-input-title-label">Your fit preference</span>
        <span class="form-input-sub-label">How do you want this to fit?</span>

        <div class="form-input">
          <fit-preference-dropdown v-model="$v.fitPreference.$model" :invalid="$v.fitPreference.$error"/>

          <div class="input-error" v-if="!$v.fitPreference.required && $v.fitPreference.$dirty">Fit preference is required</div>
        </div>
      </div>
    </div>

    <navigation/>
  </div>
</template>

<script>
import ProgressBar from "../../ProgressBar";
import Navigation from "../../Navigation";
import FitPreferenceDropdown from '../../form/FitPreferenceDropdown';
import {mapFields} from 'vuex-map-fields';
import {validationMixin} from 'vuelidate';
import {required, integer, between} from 'vuelidate/lib/validators';

export default {
  name: "AgeAndFit",

  mixins: [validationMixin],

  components: {Navigation, ProgressBar, FitPreferenceDropdown},

  computed: {
    ...mapFields('userSelections', [
      'general.age',
      'general.fitPreference',
    ]),

    ageError() {
      if (!this.$v.age.required && this.$v.age.$dirty) return 'Age is required';
      if (!this.$v.age.integer && this.$v.age.$dirty) return 'Age must be a whole number';
      if (!this.$v.age.between && this.$v.age.$dirty) return `Age must be between ${this.$v.age.$params.between.min} and ${this.$v.age.$params.between.max}`;
      return null;
    },
  },

  methods: {
    submit() {
      return new Promise(resolve => {
        this.$v.$touch();

        if (!this.$v.$invalid) {
          resolve();
        }
      });
    },
  },

  validations: {
    age: {
      required,
      integer,
      between: between(12, 99),
    },
    fitPreference: {
      required,
    },
  },
};
</script>
